import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";

import { toast } from "react-toastify";
import CustomSelect from "../../../utils/CustomSelect";
import { Button, Form, Input, Label, StyledImgUpload, Textarea } from "../../../styles";
import { useSupplierContext } from "../../../context/supplier_context";
import Api from "../../../api/axios";
import MiniLoader from "../../../utils/MIniLoader";
import { useItemContext } from "../../../context/item_context";
import { convertPhoto } from "../../../utils/helpers";
import { placeholder } from "../../../assets";


const EditItem = (props) => {
  const [issending, setissending] = useState(false);

  const [formField, setformField] = useState({
    item: '',
    icid: '',
    details: '',
    sid: '',
    photo: '',
  });

  const {
    showEditItem, CloseEditItem,
    itemCategoryData, getItemCategoryData, itemCategoryLoading,
    getItemData, getServiceData, type,
  } = useItemContext();

  const { supplierLoading, allSuppliers, getSupplierData, } = useSupplierContext();

  const { id: itemId, icid, category, item, details, sid, image } = props;

  function getFn() {
    getItemCategoryData();
    getSupplierData();
  }

  useEffect(() => {
    if (props) {
      setformField({
        icid, item, category, details, sid, photo: image
      });
    }
  }, [props]);


  function handleChange(e) {
    if (e.target.name === 'photo') {
      setformField((inputs) => ({
        ...inputs,
        [e.target.name]: e.target.files[0],
      }));
    } else {
      setformField((inputs) => ({
        ...inputs,
        [e.target.name]: e.target.value,
      }));
    }
  }

  const allCategory = itemCategoryData?.map(({ category, id }) => {
    return (
      { label: category, value: id }
    );
  });
  const supplier = allSuppliers?.map(({ name, id }) => {
    return (
      { label: name, value: id }
    );
  });

  function submitFn(e) {
    e.preventDefault();
    if (
      formField.item,
      formField.icid,
      formField.details,
      props.type
    ) {
      setissending(true);
      const data = {
        itemId,
        item: formField.item,
        icid: formField.icid,
        details: formField.details,
        sid: formField.sid,
        type: props.type,
        image: formField.photo,
      };

      Api.post(`/editItem`, data)
        .then((res) => {
          if (res.success === false) {
            toast.warn(res.message);
            setissending(false);
          } else {
            setissending(false);
            toast.success(res.message);
            getItemData();
            getServiceData();
            CloseEditItem();
          }
        })
        .catch(() => {
          setissending(false);
        });
    } else {
      setissending(false);
      toast.warn("Empty Fields !!!");
    }
  }

  return (
    <>
      <Modal
        show={showEditItem}
        onHide={CloseEditItem}
        backdrop="static"
        keyboard={true}
        onEnter={() => getFn()}
        centered
        size="lg"
      >
        <Modal.Body>
          <Modal.Header closeButton>
            <h6 className="fw-bold pry-text text-capitalize">
              Edit {type}
            </h6>
          </Modal.Header>

          <div className="container">
            <Form onSubmit={(e) => submitFn(e)}>

              <Label> Image:</Label>
              <StyledImgUpload>
                <div className="d-flex flex-wrap justify-content-center align-items-center ">
                  <img
                    src={formField.photo || placeholder}
                    alt='Item'
                    className="br-md" />
                  <p className="ms-2 pry-text"> Click to update</p>
                  <div className="file-upload">
                    <Input
                      type="file"
                      accept="image/*"
                      onChange={(e) => convertPhoto(e, setformField)}
                    />
                  </div>
                </div>

              </StyledImgUpload>

              <Label> Category: <span>*</span>
                <MiniLoader
                  load={itemCategoryLoading}
                  size={15}
                />
              </Label>
              <CustomSelect
                options={allCategory}
                isSearchable={true}
                onChange={(e) => setformField((input) => ({ ...input, icid: e.value }))}
                value={formField.icid}
                placeholder='Select Category'
                required
              />

              <Label className="text-capitalize"> {type} Name: <span>*</span></Label>
              <Input
                type="text"
                name="item"
                placeholder="e.g. Rice"
                onChange={handleChange}
                required
                value={formField.item}
              />

              <Label>Supplier:
                <MiniLoader
                  load={supplierLoading}
                  size={15}
                />
              </Label>
              <CustomSelect
                options={supplier}
                isSearchable={true}
                onChange={(e) => setformField((input) => ({ ...input, sid: e.value }))}
                value={formField.sid}
                placeholder='Select Supplier'
              />

              <Label> Description: <span>*</span></Label>
              <Textarea
                type="text"
                name="details"
                placeholder="Enter details"
                onChange={handleChange}
                required
                value={formField.details}
              />

              <div className="col-md-10 mx-auto text-center mb-4">
                <Button
                  pry
                  type="submit"
                  disabled={issending}
                  className="btn m-0 w-100"  >
                  {issending ? 'loading...' : "Submit"}
                </Button>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>

    </>
  );
};

export default EditItem;
